webpackJsonp([9],{

/***/ 2485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _error_page = __webpack_require__(2486);

var _error_page2 = _interopRequireDefault(_error_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);

    return {
        siteName: config.SiteName,
        asymmetricSigningPublicKey: config.AsymmetricSigningPublicKey
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_error_page2.default);

/***/ }),

/***/ 2486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _crypto = __webpack_require__(1422);

var _crypto2 = _interopRequireDefault(_crypto);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _constants = __webpack_require__(29);

var _error_title = __webpack_require__(2560);

var _error_title2 = _interopRequireDefault(_error_title);

var _error_message = __webpack_require__(2561);

var _error_message2 = _interopRequireDefault(_error_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ErrorPage = function (_React$PureComponent) {
    (0, _inherits3.default)(ErrorPage, _React$PureComponent);

    function ErrorPage() {
        (0, _classCallCheck3.default)(this, ErrorPage);
        return (0, _possibleConstructorReturn3.default)(this, (ErrorPage.__proto__ || (0, _getPrototypeOf2.default)(ErrorPage)).apply(this, arguments));
    }

    (0, _createClass3.default)(ErrorPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.setAttribute('class', 'sticky error');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeAttribute('class');
        }
    }, {
        key: 'render',
        value: function render() {
            var params = new URLSearchParams(this.props.location.search);
            var signature = params.get('s');

            var trustParams = false;
            if (signature) {
                params.delete('s');

                var key = this.props.asymmetricSigningPublicKey;
                var keyPEM = '-----BEGIN PUBLIC KEY-----\n' + key + '\n-----END PUBLIC KEY-----';

                var verify = _crypto2.default.createVerify('sha256');
                verify.update('/error?' + params.toString());
                trustParams = verify.verify(keyPEM, signature, 'base64');
            }

            var type = params.get('type');
            var title = trustParams && params.get('title') || '';
            var message = trustParams && params.get('message') || '';
            var service = trustParams && params.get('service') || '';
            var returnTo = trustParams && params.get('returnTo') || '';

            var backButton = void 0;
            if (type === _constants.ErrorPageTypes.PERMALINK_NOT_FOUND && returnTo) {
                backButton = _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: returnTo },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'error.generic.link',
                        defaultMessage: 'Back to Mattermost'
                    })
                );
            } else {
                backButton = _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'error.generic.link',
                        defaultMessage: 'Back to {siteName}',
                        values: {
                            siteName: this.props.siteName
                        }
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid' },
                _react2.default.createElement(
                    'div',
                    { className: 'error__container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'error__icon' },
                        _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle' })
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        _react2.default.createElement(_error_title2.default, {
                            type: type,
                            title: title
                        })
                    ),
                    _react2.default.createElement(_error_message2.default, {
                        type: type,
                        message: message,
                        service: service
                    }),
                    backButton
                )
            );
        }
    }]);
    return ErrorPage;
}(_react2.default.PureComponent);

ErrorPage.propTypes = {
    location: _propTypes2.default.object.isRequired,
    asymmetricSigningPublicKey: _propTypes2.default.string,
    siteName: _propTypes2.default.string
};
exports.default = ErrorPage;

/***/ }),

/***/ 2560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ErrorTitle;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorTitle(_ref) {
    var type = _ref.type,
        title = _ref.title;

    var errorTitle = null;
    if (type) {
        switch (type) {
            case _constants.ErrorPageTypes.LOCAL_STORAGE:
                errorTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'error.local_storage.title',
                    defaultMessage: 'Cannot Load Mattermost'
                });
                break;
            case _constants.ErrorPageTypes.PERMALINK_NOT_FOUND:
                errorTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'permalink.error.title',
                    defaultMessage: 'Message Not Found'
                });
                break;
            case _constants.ErrorPageTypes.OAUTH_MISSING_CODE:
                errorTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'error.oauth_missing_code.title',
                    defaultMessage: 'Mattermost needs your help'
                });
                break;
            case _constants.ErrorPageTypes.PAGE_NOT_FOUND:
            default:
                errorTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'error.not_found.title',
                    defaultMessage: 'Page Not Found'
                });
        }
    } else if (title) {
        errorTitle = title;
    } else {
        errorTitle = Utils.localizeMessage('error.generic.title', 'Error');
    }

    return errorTitle;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ErrorTitle.propTypes = {

    /*
    * Error type
    */
    type: _propTypes2.default.string,

    /*
    * Error title
    */
    title: _propTypes2.default.string
};

/***/ }),

/***/ 2561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ErrorMessage;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _error_link = __webpack_require__(2562);

var _error_link2 = _interopRequireDefault(_error_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorMessage(_ref) {
    var type = _ref.type,
        message = _ref.message,
        service = _ref.service;

    var errorMessage = null;
    if (type) {
        switch (type) {
            case _constants.ErrorPageTypes.LOCAL_STORAGE:
                errorMessage = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'error.local_storage.message',
                        defaultMessage: 'Mattermost was unable to load because a setting in your browser prevents the use of its local storage features. To allow Mattermost to load, try the following actions:'
                    }),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'error.local_storage.help1',
                                defaultMessage: 'Enable cookies'
                            })
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'error.local_storage.help2',
                                defaultMessage: 'Turn off private browsing'
                            })
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'error.local_storage.help3',
                                defaultMessage: 'Use a supported browser (IE 11, Chrome 43+, Firefox 38+, Safari 9, Edge)'
                            })
                        )
                    )
                );
                break;
            case _constants.ErrorPageTypes.PERMALINK_NOT_FOUND:
                errorMessage = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'permalink.error.access',
                        defaultMessage: 'Permalink belongs to a deleted message or to a channel to which you do not have access.'
                    })
                );
                break;
            case _constants.ErrorPageTypes.OAUTH_MISSING_CODE:
                errorMessage = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'error.oauth_missing_code',
                            defaultMessage: 'The service provider {service} did not provide an authorization code in the redirect URL.',
                            values: {
                                service: service
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'error.oauth_missing_code.google',
                            defaultMessage: 'For {link} make sure your administrator enabled the Google+ API.',
                            values: {
                                link: _react2.default.createElement(_error_link2.default, {
                                    url: 'https://docs.mattermost.com/deployment/sso-google.html',
                                    messageId: 'error.oauth_missing_code.google.link',
                                    defaultMessage: 'Google Apps'
                                })
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'error.oauth_missing_code.office365',
                            defaultMessage: 'For {link} make sure the administrator of your Microsoft organization has enabled the Mattermost app.',
                            values: {
                                link: _react2.default.createElement(_error_link2.default, {
                                    url: 'https://docs.mattermost.com/deployment/sso-office.html',
                                    messageId: 'error.oauth_missing_code.office365.link',
                                    defaultMessage: 'Office 365'
                                })
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'error.oauth_missing_code.gitlab',
                            defaultMessage: 'For {link} please make sure you followed the setup instructions.',
                            values: {
                                link: _react2.default.createElement(_error_link2.default, {
                                    url: 'https://docs.mattermost.com/deployment/sso-gitlab.html',
                                    messageId: 'error.oauth_missing_code.gitlab.link',
                                    defaultMessage: 'GitLab'
                                })
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'error.oauth_missing_code.forum',
                            defaultMessage: 'If you reviewed the above and are still having trouble with configuration, you may post in our {link} where we\'ll be happy to help with issues during setup.',
                            values: {
                                link: _react2.default.createElement(_error_link2.default, {
                                    url: 'https://forum.mattermost.org/c/trouble-shoot',
                                    messageId: 'error.oauth_missing_code.forum.link',
                                    defaultMessage: 'Troubleshooting forum'
                                })
                            }
                        })
                    )
                );
                break;
            case _constants.ErrorPageTypes.PAGE_NOT_FOUND:
            default:
                errorMessage = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'error.not_found.message',
                        defaultMessage: 'The page you were trying to reach does not exist'
                    })
                );
        }
    } else if (message) {
        errorMessage = _react2.default.createElement(
            'p',
            null,
            message
        );
    } else {
        errorMessage = _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'error.generic.message',
                defaultMessage: 'An error has occurred.'
            })
        );
    }

    return errorMessage;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ErrorMessage.propTypes = {

    /*
    * Error type
    */
    type: _propTypes2.default.string,

    /*
    * Error message
    */
    message: _propTypes2.default.string,

    /*
    * Service provider
    */
    service: _propTypes2.default.string
};

/***/ }),

/***/ 2562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ErrorLink;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorLink(_ref) {
    var url = _ref.url,
        messageId = _ref.messageId,
        defaultMessage = _ref.defaultMessage;

    return _react2.default.createElement(
        'a',
        {
            href: url,
            rel: 'noopener noreferrer',
            target: '_blank'
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: messageId,
            defaultMessage: defaultMessage
        })
    );
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ErrorLink.propTypes = {
    url: _propTypes2.default.string.isRequired,
    messageId: _propTypes2.default.string.isRequired,
    defaultMessage: _propTypes2.default.string.isRequired
};

ErrorLink.defaultProps = {
    url: '',
    messageId: '',
    defaultMessage: ''
};

/***/ })

});


// WEBPACK FOOTER //
// 9.141d2923d3486feee4d2.js